import PazienteConsensiList from "./pages/PazienteConsensiList.vue";
export default {
    PazienteConsensiList
};
